import React from 'react';
import NavBar from './navbar_in';

class PricingPage extends React.Component{

    componentWillMount()
    {
        window.scrollTo(0, 0);
    }

    Onclick(e)
    {
        this.props.history.push('/');
    }

    render()
    {
        return(
            <div>
            <NavBar />
            <section id='about' style={{backgroundColor: '#fdebe2'}}>
        <div className="container">
            <h3  style={{color: '#737272'}}>Pricing</h3>
            <hr  style={{backgroundColor: '#737272'}}/>
            <div class="row">

 <div class="col s12 m12">
          <div class="card">
          <div class="card-panel red lighten-2" style={{textAlign:'center', verticalAlign: 'middle', fontSize: '16px'}}><b>Bridal Platinum Package</b></div>
    
            <div class="card-content">
            <ul class="collection">
            <li class="collection-item">5 Hours Work</li>
            <li class="collection-item">Facial mask (types upon discuss)</li>
      <li class="collection-item">Makeup & Hair (includes custom lashes and optional airbrush makeup)</li>
      <li class="collection-item">Touch Up Services </li>
      <li class="collection-item">Optional one Hairstyle change before reception</li>
      <li class="collection-item">Makeup & Hair Touch Up Kit (lip color, under eye concealer, Q-tips, Bobbi pins, small bottle of hair spray, blotting papers) </li>
      <li class="collection-item">Travel (up to 30 miles outside San Jose 95136. Tolls, and Parking are not included.) </li>
      <li class="collection-item"><span class="badge">$980</span></li>
    </ul>
            </div>
          </div>
        </div>
        
      </div>

           <div class="col s12 m12">
          <div class="card">
          <div class="card-panel red lighten-2" style={{textAlign:'center', verticalAlign: 'middle', fontSize: '16px'}}><b>Bridal (3 hours)</b></div>
    
    <div class="card-content">
    <ul class="collection">
    <li class="collection-item"><span class="badge">$700</span>Makeup & Hair (Includes lashes and optional airbrush makeup)</li>
      <li class="collection-item"><span class="badge">$350</span> Makeup Only</li>
      <li class="collection-item"><span class="badge">$350</span>Hair Only</li>
    </ul>
            </div>
            
          </div>
        </div>


       <div class="row">
        <div class="col s12 m12">
          <div class="card">
          <div class="card-panel red lighten-2" style={{textAlign:'center', verticalAlign: 'middle', fontSize: '16px'}}><b>ENGAGEMENT</b></div>
    
    <div class="card-content">
    <ul class="collection">
    <li class="collection-item"><span class="badge">$200</span>Makeup Only</li>
      <li class="collection-item"><span class="badge">$200</span>Hair Only</li>
      <li class="collection-item"><span class="badge">$400</span>Makeup & Hair</li>
    </ul>
            </div>
            
          </div>
        </div>

 <div class="col s12 m12">
          <div class="card">
          <div class="card-panel red lighten-2" style={{textAlign:'center', verticalAlign: 'middle', fontSize: '16px'}}><b>SPECIAL OCCASION</b></div>
    
    
            <div class="card-content">
            <ul class="collection">
      <li class="collection-item"><span class="badge">$150</span>Makeup Only</li>
      <li class="collection-item"><span class="badge">$150</span>Hair Only</li>      
      <li class="collection-item"><span class="badge">$300</span>Makeup & Hair</li>
    </ul>
            </div>
          </div>
        </div>

         <div class="col s12 m12">
          <div class="card">
          <div class="card-panel red lighten-2" style={{textAlign:'center', verticalAlign: 'middle', fontSize: '16px'}}><b>Consultation & Trial</b></div>
    
    
            <div class="card-content">
            <ul class="collection">
      <li class="collection-item"><span class="badge">$150</span>Makeup</li>
      <li class="collection-item"><span class="badge">$150</span>Hair</li>
    </ul>
            </div>
          </div>
        </div>
        
      </div>


      <div class="row">
        <div class="col s12 m12">
          <div class="card">
          <div class="card-panel red lighten-2" style={{textAlign:'center', verticalAlign: 'middle', fontSize: '16px'}}><b>Other Fees</b></div>
    
    <div class="card-content">
    <p>Aditional People(when booking bridal package)</p>
    <ul class="collection">
    <li class="collection-item"><span class="badge">$150</span>Makeup</li>
      <li class="collection-item"><span class="badge">$150</span>Hair</li>
    </ul>
    <p>Add-ons</p>
     <ul class="collection">
    <li class="collection-item"><span class="badge">upon consultation</span>Airbrush</li>
      <li class="collection-item"><span class="badge">$40+</span>Clip-on Hair Extensions application(Extensions are not included. Please bring your own extensions or purchase at here)</li>
      <li class="collection-item"><span class="badge">$250/hr</span>Stay and Touch Up </li>
      <li class="collection-item"><span class="badge">upon consultation</span>Tattoo cover up</li>
    </ul>
            </div>
            
          </div>
        </div>

        
      </div>

      <div class="row">
      <div class="col s12 m12">
          <div class="card">
          <div class="card-panel red lighten-2" style={{textAlign:'center', verticalAlign: 'middle', fontSize: '16px'}}><b>Terms</b></div>
    
    <div class="card-content">
    <div>
    <ul class="collection">
    <li class="collection-item">Travel fees: $2 per mile round trip (to location and back), from San Jose 95136 </li>
      <li class="collection-item">Early fees: Start before 8 am add $50, before 6 am add $100, at or before 5 am add $150, at or before 4 am add $200</li>
      <li class="collection-item">A 50% deposit (brides's total price) with contract is required to reserve dates (NON-REFUNDABLE and NON-TRANSFERABLE)</li>
      <li class="collection-item">Dates are not guaranteed or held without a contract and deposit</li>
      <li class="collection-item">Lodging is required when working more than 6 hours or more than 100 miles away from San Jose</li>
      <li class="collection-item">A vendor meal is required when working more than 4 hour</li>
      <li class="collection-item">Hotel parking fees will be charged to the contract or hotel room charges on the day of the event, if a parking fee is required</li>
    </ul>
    <div style={{marginBottom: '50px'}}><span class="badge"  style={{fontSize:'smaller'}}>*Prices and information on this site are subject to change without notice</span></div>
    </div>
            </div>
            
          </div>
        </div> 
      </div>


        </div>
        </section>
        </div>
        );

    }
}

export default PricingPage;



// WEBPACK FOOTER //
// ./src/components/pricingPage.js